import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import ProfessionalWebsites from './pages/solutions/ProfessionalWebsites';
import CustomerCommunication from './pages/solutions/CustomerCommunication';
import AppointmentCoordination from './pages/solutions/AppointmentCoordination';
import BusinessWorkflow from './pages/solutions/BusinessWorkflow';
import LeadQualification from './pages/solutions/LeadQualification';
import InternalOrganization from './pages/solutions/InternalOrganization';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/solutions/professional-websites" element={<ProfessionalWebsites />} />
          <Route path="/solutions/customer-communication" element={<CustomerCommunication />} />
          <Route path="/solutions/appointment-coordination" element={<AppointmentCoordination />} />
          <Route path="/solutions/business-workflow" element={<BusinessWorkflow />} />
          <Route path="/solutions/lead-qualification" element={<LeadQualification />} />
          <Route path="/solutions/internal-organization" element={<InternalOrganization />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
